import React, { useReducer } from 'react';
import { getClub, listClubs } from '../graphql/queries';
import { API } from 'aws-amplify';
import { createClub, deleteClub } from '../graphql/mutations';

const ClubContext = React.createContext();
const _clubState = {
    clubs : []
};

function clubReducer(state , {type , data}){
    switch (type) {
        case "SET_CLUBS" : {
            return {
                ...state,
                clubs : data
            };
        }
        default:
            break;
    }
}

const ClubProvider = ({ children }) => {
    const [clubState, dispatch  ] = useReducer(clubReducer , _clubState);
    async function getClubs(){
        try {
            const {data  : { listClubs : {items : clubs}}} = await API.graphql({query : listClubs});
            dispatch({type : "SET_CLUBS" , data : clubs});
        } catch (err) {
            console.log(err);
        }
    }
    async function retreiveClub(id){
        try{
            const club = await API.graphql({query : getClub , variables :  {input : {id}}});
            return club;
        }
        catch(err){
            console.log(err);
        }
    }
    async function addClub(clubDetails){
        try{
            const {data  : { listClubs : {items : clubs}}}  = await API.graphql({query : listClubs  ,  variables :  { filter : { name : {eq : clubDetails.name} } } });
            if(clubs.length > 0){
                throw("Clubs with name exists");
            }
            await API.graphql({query : createClub  , variables :  {input : clubDetails}});
            await getClubs();
        }
        catch(err){
            console.log(err);
        }
    }
    async function removeClub(clubDetails){
        try{
            await API.graphql({query : deleteClub  , variables :  {input : clubDetails}});
            await getClubs();
        }
        catch(err){
            console.log(err);
        }
    }
    return (
        <ClubContext.Provider value={{ clubState , getClubs , addClub ,retreiveClub , removeClub}}>
            {children}
        </ClubContext.Provider>
    );
};
export { ClubContext , ClubProvider};